import { PropsWithChildren } from 'react';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Card = ({ children, gradientBottom = false }: PropsWithChildren<Props>) => {
  const classNames =
    'relative overflow-hidden light:bg-uniform-gray-50 light:text-uniform-gray-800 dark:bg-uniform-gray-800 dark:text-uniform-white-base rounded-lg p-4';

  return (
    <div className={classNames}>
      {gradientBottom && (
        <img
          src="/images/umo-nm-gradient-bg.png"
          alt=""
          aria-hidden
          className="absolute -bottom-1/4 left-1/2 translate-x-[-50%] scale-[1.5] pointer-events-none select-none block"
          style={{
            zIndex: 0
          }}
        />
      )}

      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default Card;
